import { ReactNode, useCallback, useState } from 'react';
import useApiCall from '../../../../../hooks/useApiCall';
import LinesService from '../../../../../services/affreightment/LinesService';
import { toast } from 'react-toastify';
import { LineBeingDeletedType } from '../../types';
import { useAppContext } from '../../../../../contexts/auth';

interface UseDeleteLineInterface {
  loadLines: () => void;
}

export default function useDeleteLine({ loadLines }: UseDeleteLineInterface) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [lineBeingDeleted, setLineBeingDeleted] = useState<LineBeingDeletedType>({} as LineBeingDeletedType);

  const { userData, token, selectedCompany } = useAppContext();
  const { apiCall } = useApiCall();
  const companyCode = selectedCompany.value;

  const { userCode, userProfile, userName } = userData;

  const directionTagLiterals: { [key: number]: ReactNode } = {
    0: '',
    1: <small>Ida</small>,
    2: <small className="orange">Volta</small>,
  };

  const deleteLine = useCallback(async () => {
    await apiCall({
      apiToCall: LinesService.deleteLine,
      queryParams: {
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: companyCode,
        token,
        codLinhaSis: lineBeingDeleted.lineId,
        routeId: encodeURIComponent(lineBeingDeleted.routeId),
      },
      onStartLoad: () => setIsDeleting(true),
      onEndLoad: () => setIsDeleting(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível deletar a linha. Por favor, tente novamente (${response.msg})`);
          return;
        }
        setModalDeleteShow(false);
        loadLines();
        toast.success('A linha foi removida com sucesso!');
      }
    });
  }, [apiCall, companyCode, lineBeingDeleted.lineId, lineBeingDeleted.routeId, loadLines, token, userCode, userName, userProfile]);

  return {
    isDeleting,
    modalDeleteShow,
    setModalDeleteShow,
    lineBeingDeleted,
    setLineBeingDeleted,
    directionTagLiterals,
    deleteLine,
  };
}
